import type {Media} from '../types';

export const filterOnlyLatest = (media: Media[]): Media[] => {
  media.sort((a: Media, b: Media) => {
    if (a.version > b.version) {
      return -1;
    }
    if (a.version < b.version) {
      return 1;
    }

    return 0;
  });

  return media.filter((value, index, self) => {
    if (value.subType === 'ATTACHMENT') {
      // Attachment has to check fileNr aswell
      const testAttachment = self.findIndex(
        m =>
          m.type === value.type &&
          m.subType === value.subType &&
          m.fileNr === value.fileNr,
      );

      if (index === testAttachment) {
        return true;
      }
    }

    const testOther = self.findIndex(
      m => m.type === value.type && m.subType === value.subType,
    );

    return index === testOther;
  });
};
